import { render, staticRenderFns } from "./box-1-unit-2.vue?vue&type=template&id=72f4589f&scoped=true&"
import script from "./box-1-unit-2.vue?vue&type=script&lang=ts&"
export * from "./box-1-unit-2.vue?vue&type=script&lang=ts&"
import style0 from "./box-1-unit-2.vue?vue&type=style&index=0&id=72f4589f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72f4589f",
  null
  
)

export default component.exports